<template>
    <development>
        <div>
            <development-heading>Notifications</development-heading>
            <base-notifications ref="base-notifications"/>

            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications')" color="danger">Danger</base-button>
            </div>

            <development-heading :level="2">Props :</development-heading>
            <ul>
                <li><strong>dismissible</strong>: Boolean</li>
                <li><strong>elevated</strong>: Boolean</li>
                <li><strong>large</strong>: Boolean</li>
                <li><strong>pill</strong>: Boolean</li>
                <li><strong>small</strong>: Boolean</li>
                <li><strong>xSmall</strong>: Boolean</li>
            </ul>

            <development-heading>Dismissible</development-heading>
            <base-notifications ref="base-notifications-dismissible" dismissible/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-dismissible')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-dismissible')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-dismissible')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-dismissible')" color="danger">Danger</base-button>
            </div>

            <development-heading>Elevated</development-heading>
            <base-notifications ref="base-notifications-elevated" elevated/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-elevated')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-elevated')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-elevated')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-elevated')" color="danger">Danger</base-button>
            </div>

            <development-heading>Large</development-heading>
            <base-notifications ref="base-notifications-large" large/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-large')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-large')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-large')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-large')" color="danger">Danger</base-button>
            </div>

            <development-heading>Small</development-heading>
            <base-notifications ref="base-notifications-small" small/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-small')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-small')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-small')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-small')" color="danger">Danger</base-button>
            </div>

            <development-heading>xSmall</development-heading>
            <base-notifications ref="base-notifications-xSmall" x-small/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-xSmall')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-xSmall')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-xSmall')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-xSmall')" color="danger">Danger</base-button>
            </div>

            <development-heading>Pill</development-heading>
            <base-notifications ref="base-notifications-pill" pill/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-pill')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-pill')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-pill')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-pill')" color="danger">Danger</base-button>
            </div>

            <development-heading>Full example</development-heading>
            <base-notifications ref="base-notifications-example" elevated dismissible x-small pill/>
            <div class="space-y-2 mb-4">
                <base-button @click="info('base-notifications-example')" color="primary">Info</base-button>
                <base-button @click="success('base-notifications-example')" color="available">Success</base-button>
                <base-button @click="warning('base-notifications-example')" color="busy">Warning</base-button>
                <base-button @click="danger('base-notifications-example')" color="danger">Danger</base-button>
            </div>
        </div>
    </development>
</template>

<script>
import Development from "./Development";
import DevelopmentHeading from "./elements/DevelopmentHeading";
import DevelopmentParagraph from "./elements/DevelopmentParagraph";
import BaseNotifications from "../elements/BaseNotifications.vue";

export default {
    name: "DevelopmentNotifications",
    components: {
        BaseNotifications,
        Development,
        DevelopmentHeading,
        DevelopmentParagraph,
    },
    methods: {
        info(notificationsRef) {
            this.$refs[notificationsRef].info('Notification : info');
        },
        success(notificationsRef) {
            this.$refs[notificationsRef].success('Notification : success');
        },
        warning(notificationsRef) {
            this.$refs[notificationsRef].warning('Notification : warning');
        },
        danger(notificationsRef) {
            this.$refs[notificationsRef].danger('Notification : danger');
        },
    }
}
</script>
